import {Component, forwardRef, Injector} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {AbstractInvertedBooleanEditControlComponent} from "../abstract-inverted-boolean-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InvertedCheckboxEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-inverted-checkbox-edit-control",
    templateUrl: "inverted-checkbox-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR]
})
export class InvertedCheckboxEditControlComponent extends AbstractInvertedBooleanEditControlComponent {

    constructor(injector: Injector) {
        super(injector);
    }
}
